
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 416 448","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M192 80v176c0 70.5-57.5 128-128 128H48c-8.75 0-16-7.25-16-16v-32c0-8.75 7.25-16 16-16h16c35.25 0 64-28.75 64-64v-8c0-13.25-10.75-24-24-24H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm224 0v176c0 70.5-57.5 128-128 128h-16c-8.75 0-16-7.25-16-16v-32c0-8.75 7.25-16 16-16h16c35.25 0 64-28.75 64-64v-8c0-13.25-10.75-24-24-24h-56c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48z"}})])
          )
        }
      }
    